export default __webpack_public_path__ + "static/5-tips-for-travelling-around-europe-in-winter-stay-indoors-8fff5a63af2ec9ea2c842905bd621bd1.jpg";